import styled from 'styled-components';

export const Tabs = styled.nav`
  display: flex;
  padding: 8px 16px 0 16px;
  overflow: hidden; // shadow cutoff
`;
